// Added by Sejune Oh on 2019-03-19
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React from 'react'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Prime elements
import { TableRow, TableCell, TableBody } from '@/components/_primes'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
import { TableBodyPartialProps } from '../TableContainer'

export interface TableBodyBaseFCProps extends TableBodyPartialProps {
    isSelectable?: boolean
    rowElements?: Array<JSX.Element>
}

interface TableBodyFCProps extends TableBodyBaseFCProps {}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const CustomTableBody = (props: TableBodyFCProps) => {
    return (
        <>
            {props.rowElements}

            {props.emptyRowsCount > 0 && (
                <TableBody>
                    <TableRow style={{ height: props.defaultRowHeight * props.emptyRowsCount }}>
                        <TableCell colSpan={props.colSpan} />
                    </TableRow>
                </TableBody>
            )}
        </>
    )
}

export default CustomTableBody
